export default __webpack_public_path__ + "static/media/pantry1-afterI-1440w.b469a1f6.webp";